
<div class="bankid-view text-left">
  <div class="bankid-view__title q-mt-lg flex row justify-between">
    <div class="col-1">
      <ws-button
        class="text-ws-ui-primary q-mr-md"
        icon="arrow_left"
        :aria-label="$t('general.accessibility.button.back_button')"
        @click="goBack"
      />
    </div>
    <div class="col-10">
      <h5>{{ $t('bank_id.create_new_user.title') }}</h5>
      <p id="qr_description" class="small">
        {{ $t('bank_id.create_new_user.description') }}
      </p>
    </div>
  </div>
  <div class="bankid-view__content column justify-center q-mt-lg">
    <div class="bankid-view__qrcode text-center">
      <div v-if="!loading && !allowRepeat" class="qr-code-wrapper q-mb-md">
        <ws-qr-code
          aria-labelledby="qr_description"
          :aria-label="$t('general.accessibility.qr_code')"
          :content="qrCode"
        />
      </div>
      <ws-button
        v-if="!loading && !allowRepeat"
        :aria-label="$t('bank_id.accessibility.open_bank_id_application')"
        :type="WsButtonEnum.Type.TERTIARY_NEUTRAL"
        icon="restore"
        :size="WsButtonEnum.Size.MEDIUM"
        @click="openInApp"
      >
        {{ $t('bank_id.create_new_user.open_in_app') }}
      </ws-button>
    </div>
    <div class="bankid-view__qr-error text-center">
      <ws-button
        v-if="!loading && allowRepeat"
        :aria-label="$t('bank_id.accessibility.start_again')"
        :type="WsButtonEnum.Type.TERTIARY_NEUTRAL"
        icon="restore"
        :size="WsButtonEnum.Size.MEDIUM"
        @click="initiateQrCode"
      >
        {{ $t('bank_id.create_new_user.qr_error_button') }}
      </ws-button>
      <ws-spinner v-if="loading" :alt="$t('general.accessibility.loading')" />
    </div>
  </div>
  <div class="q-my-lg">
    <ws-delimiter text="wsk.general.or" alt="" aria-hidden="true" />
  </div>
</div>
